import { Button, Modal, Typography } from 'antd';

import type { AlertsDefaultOptionsStateName } from '..';

type AlertsDefaultOptionsProps = {
  showAlert: {
    pix: boolean;
    automaticPix: boolean;
    card: boolean;
    boleto: boolean;
    multipleCards: boolean;
    eduzzBalance: boolean;
    combinedPayment: boolean;
  };
  toggleAlert: (alertName: AlertsDefaultOptionsStateName) => void;
  onToggleConfirmed: (fieldId: string, checked: boolean) => void;
};

function AlertsDefaultOptions({ showAlert, toggleAlert, onToggleConfirmed }: AlertsDefaultOptionsProps) {
  const showAlertPix = showAlert.pix;
  const showAlertAutomaticPix = showAlert.automaticPix;
  const showAlertCard = showAlert.card;
  const showAlertBoleto = showAlert.boleto;
  const showAlertMultipleCards = showAlert.multipleCards;
  const showAlertEduzzBalance = showAlert.eduzzBalance;
  const showAlertCombinedPayment = showAlert.combinedPayment;

  const toggleAlertPix = () => toggleAlert('showAlertPix');
  const toggleAlertAutomaticPix = () => toggleAlert('showAlertAutomaticPix');
  const toggleAlertCard = () => toggleAlert('showAlertCard');
  const toggleAlertBoleto = () => toggleAlert('showAlertBoleto');
  const toggleAlertMultipleCards = () => toggleAlert('showAlertMultipleCards');
  const toggleAlertEduzzBalance = () => toggleAlert('showAlertEduzzBalance');
  const toggleAlertCombinedPayment = () => toggleAlert('showAlertCombinedPayment');

  const handleToggleConfirmed = (fieldId: string, checked: boolean, callback: () => void) => {
    onToggleConfirmed(fieldId, checked);
    callback();
  };

  const dialogsList = [
    {
      id: 'pix',
      show: showAlertPix,
      fieldId: 'allows_pix',
      contentText:
        'Desativar o pagamento via PIX pode reduzir suas vendas em até 47% e limitar o potencial de conversão do seu produto.',
      onCancel: toggleAlertPix,
      onConfirm: () => handleToggleConfirmed('allows_pix', false, toggleAlertPix)
    },
    {
      id: 'automatic-pix',
      show: showAlertAutomaticPix,
      fieldId: 'allows_automatic_pix',
      contentText:
        'Desativar o Pix Automático pode aumentar a inadimplência das suas assinaturas e reduzir a retenção de clientes, já que os pagamentos passam a depender de uma ação manual do assinante.',
      onCancel: toggleAlertAutomaticPix,
      onConfirm: () => handleToggleConfirmed('allows_automatic_pix', false, toggleAlertAutomaticPix)
    },
    {
      id: 'card',
      show: showAlertCard,
      fieldId: 'allows_card',
      contentText:
        'Cartões concentram cerca de 89% das transações na Eduzz. Ignorar essa preferência pode comprometer seus resultados.',
      onCancel: toggleAlertCard,
      onConfirm: () => handleToggleConfirmed('allows_card', false, toggleAlertCard)
    },
    {
      id: 'boleto',
      show: showAlertBoleto,
      fieldId: 'allows_boleto',
      contentText:
        'Um em cada três clientes escolhe pagar por boleto. Deixe essa opção disponível e potencialize o alcance do seu produto.',
      onCancel: toggleAlertBoleto,
      onConfirm: () => handleToggleConfirmed('allows_boleto', false, toggleAlertBoleto)
    },
    {
      id: 'multiple-card',
      show: showAlertMultipleCards,
      fieldId: 'allows_multiple_cards',
      contentText:
        'Clientes querem flexibilidade. Com dois cartões na mesma compra, suas vendas podem crescer até 18%.',
      onCancel: toggleAlertMultipleCards,
      onConfirm: () => handleToggleConfirmed('allows_multiple_cards', false, toggleAlertMultipleCards)
    },
    {
      id: 'eduzz-balance',
      show: showAlertEduzzBalance,
      fieldId: 'allows_eduzz_balance',
      contentText: 'Ao desativar, seus compradores não poderão pagar com saldo Eduzz.',
      onCancel: toggleAlertEduzzBalance,
      onConfirm: () => handleToggleConfirmed('allows_eduzz_balance', false, toggleAlertEduzzBalance)
    },
    {
      id: 'combine-payment',
      show: showAlertCombinedPayment,
      fieldId: 'allows_combine_payment',
      contentText:
        'Desativar o Pagamento Combinado pode reduzir suas vendas em até 47% e limitar o potencial de conversão do seu produto.',
      onCancel: toggleAlertCombinedPayment,
      onConfirm: () => handleToggleConfirmed('allows_combine_payment', false, toggleAlertCombinedPayment)
    }
  ];

  return (
    <>
      {dialogsList.map(dialog => (
        <Modal
          key={dialog.id}
          open={dialog.show}
          onCancel={dialog.onCancel}
          title='Tem certeza que deseja desativar esta funcionalidade?'
          footer={
            <div className='flex flex-wrap items-center justify-end gap-2'>
              <Button type='text' id={`alert-dialog-${dialog.id}-btn-confirm`} onClick={dialog.onConfirm}>
                Desativar mesmo assim
              </Button>
              <Button id={`alert-dialog-${dialog.id}-btn-cancel`} onClick={dialog.onCancel} type='primary'>
                Manter ativado
              </Button>
            </div>
          }
        >
          <Typography.Paragraph>{dialog.contentText}</Typography.Paragraph>
        </Modal>
      ))}
    </>
  );
}

export default AlertsDefaultOptions;
